import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

import Button from '../ui/Button';
import Spinner from '../ui/Spinner';
import { formatPrice } from '../../utils/money';

// Rendered inside <Elements> (which holds the balance-intent clientSecret).
// Confirms the payment, then hands control back to the order detail page,
// which polls the order until the webhook flips balanceDue to 0 — this
// component never marks the order paid itself.
export default function BalancePaymentStep({ amount, orderNumber, onPaid, onCancel }) {
  const stripe = useStripe();
  const elements = useElements();

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setSubmitting(true);
    setError(null);

    const { error: stripeError } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/order/${orderNumber}`,
      },
      redirect: 'if_required',
    });

    if (stripeError) {
      setError(stripeError.message || 'Payment could not be completed.');
      setSubmitting(false);
      return;
    }

    onPaid();
  };

  return (
    <form className="ss-pay" onSubmit={onSubmit}>
      {error && <p className="ss-form__error" role="alert">{error}</p>}
      <PaymentElement />
      <div style={{ display: 'flex', gap: 'var(--ss-space-3)' }}>
        <Button type="submit" disabled={!stripe || submitting}>
          {submitting ? <Spinner label="Processing payment" /> : `Pay ${formatPrice(amount)}`}
        </Button>
        <Button type="button" variant="ghost" onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>
      </div>
    </form>
  );
}
